import React, { useMemo } from 'react';
import { CircularProgress } from '@mui/material';

import { getFormattedDate } from '../../../../../utils/dates';
import { ITicketNote } from '../../../../../services/tickets/types';

import useStyles from '../../../styles';

interface IProps {
  note: ITicketNote;
}

const TicketTimelineItem: React.FC<IProps> = ({ note }) => {
  const classes = useStyles();

  const componentFooter = useMemo(() => {
    switch (note.status) {
      case 'loading':
        return (
          <>
            <CircularProgress style={{ width: '10px', height: '10px' }} />
          </>
        );
      default:
        return <>{getFormattedDate(note.dateCreated, 'hh:mm a')}</>;
    }
  }, [note.status, note.dateCreated]);

  const noteText = useMemo(() => {
    const textArr = note.text.split('\r\n');

    return textArr.map(i => {
      const separatorIndex = i.indexOf(':');

      if (separatorIndex === -1) {
        return (
          <div key={i} className={classes.noteText}>
            {i}
          </div>
        );
      }

      const title = i.slice(0, separatorIndex);
      const text = i.slice(separatorIndex + 1).trim();

      return (
        <div key={i} className={classes.noteText}>
          <p>{title}:</p>
          {text}
        </div>
      );
    });
  }, [note.text]);

  if (!note.text) return null;

  return (
    <div key={note.id} className={classes.ticketNote}>
      <div className={classes.ticketNoteContent}>{noteText}</div>

      <div className={classes.ticketNoteHeader}>
        <div>{note.createdBy}</div>
        <div>{componentFooter}</div>
      </div>
    </div>
  );
};

export default TicketTimelineItem;
